export * from './modules';
export * from './pipes/shared-pipes.module';
export * from './guard';



// WEBPACK FOOTER //
// ./src/app/shared/index.ts